import { Role } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

export const findSubscriptionIndex = (orgRoleObj: Role) => {
  for (let i = 0; i < orgRoleObj.subscription.length; i++) {
    if (orgRoleObj.subscription[i].owner === orgRoleObj.id) {
      return i;
    }
  }
  return 0;
};
